import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { environment } from '@perval/shared';
import { PTableHeader } from '../../../shared/design-system/organisms/p-table/p-table-header';
import { ServicePerval } from '../../models/service-perval';
import { ReportService } from '../../../rapport/services/report.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-historique-services-table',
  templateUrl: './historique-services-table.component.html',
  styleUrls: ['./historique-services-table.component.scss'],
})
export class HistoriqueServicesTableComponent implements OnChanges {
  @Input() serviceHistory!: ServicePerval.History;
  @Input() limit!: number; // Nombre d'éléments par page (pagination)
  @Input() canAccessReport!: boolean;
  @Input() canDownloadReport!: boolean;
  @Input() canEditReport!: boolean;

  @Output() pageChanged = new EventEmitter<number>();
  @Output() sortChanged = new EventEmitter<{
    key: string;
    direction: 'asc' | 'desc';
  }>();

  currentPage: number = 1;
  totalPages: number = 1;
  showEditAndDownloadButtons: boolean = false;

  // Colonnes de la table historique des services
  headers: PTableHeader[] = [
    { label: 'Date', key: 'happened_at', width: '20%', sortable: true },
    { label: 'Service', key: 'service', width: '20%', sortable: true },
    {
      label: 'Type de bien',
      key: 'property_type',
      width: '15%',
      sortable: true,
    },
    {
      label: 'Localisation',
      key: 'localisation',
      width: '25%',
      sortable: true,
    },
  ];

  constructor(
    private readonly reportService: ReportService,
    private readonly router: Router,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    const canAccessReport = changes['canAccessReport']?.currentValue;
    if (canAccessReport) {
      this.headers.push({
        label: 'Accès',
        key: 'historyId',
        width: '10%',
      });
    }

    const canDownloadReport = changes['canDownloadReport']?.currentValue;
    const canEditReport = changes['canEditReport']?.currentValue;
    if (canDownloadReport || canEditReport) {
      this.headers.push({
        label: 'Rapport',
        key: 'serviceUsageId',
        width: '10%',
      });
    }

    this.calculateTotalPages();
  }

  public getFullServiceUrl(url: string): string {
    return `${environment.host}/${url}`;
  }

  public onPageChanged(newPage: number): void {
    if (newPage >= 1 && newPage <= this.totalPages) {
      this.currentPage = newPage;
      const offset = (this.currentPage - 1) * this.limit;
      this.pageChanged.emit(offset);
    }
  }

  public onSortChanged(event: {
    key: string | null;
    direction: 'asc' | 'desc' | null;
  }): void {
    if (event.key && event.direction) {
      this.sortChanged.emit({ key: event.key, direction: event.direction });
    } else {
      this.sortChanged.emit({ key: 'happened_at', direction: 'desc' });
    }
  }

  public async onDownloadReport(item: ServicePerval): Promise<void> {
    await this.reportService.generateReport(item.reportId);
  }

  public async onEditReport(item: ServicePerval): Promise<void> {
    // redirect to /rapport/:reportId
    this.router.navigate([`/rapport/${item.reportId}`]);
  }

  // Calculer le nombre total de pages en fonction des résultats totalResult
  private calculateTotalPages(): void {
    this.totalPages = Math.ceil(this.serviceHistory?.totalResult / this.limit);
    if (this.currentPage > this.totalPages) {
      this.currentPage = this.totalPages;
    }
  }
}
